@if (to["multiple"]) {
  <fd-multi-input
    [state]="showError ? 'error' : null"
    [dropdownValues]="to.options | formlySelectOptions: field | async"
    [required]="to.required"
    [formlyAttributes]="field"
    [formControl]="formControl"
    [displayFn]="displayFunction"
    [valueFn]="valueFn"
  >
  </fd-multi-input>
} @else {
  <fd-select
    [formControl]="formControl"
    [required]="to.required"
    [formlyAttributes]="field"
    fdCompact
    fillControlMode="equal"
    [inline]="false"
    [placeholder]="to.placeholder"
    [state]="showError ? 'error' : null"
  >
    @if (to.options | formlySelectOptions: field | async; as opts) {
      @for (opt of opts; track opt) {
        <fd-option [value]="opt.value" [disabled]="opt.disabled">{{
          opt.label
        }}</fd-option>
      }
    }
  </fd-select>
}
